export const EMPTY_ARRAY = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});
export const PROFILE_PREVIEW_KEY = 'previewProfile';

export const DENOUNCE_FORM_CANCEL_MODAL_KEY = 'denounce_form_cancel_modal';
